import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import App from "./App";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import { DashboardThemeProvider } from "./context/DashboardThemeContext";
import { AlertProvider } from "./context/AlertContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <DashboardThemeProvider>
        <AlertProvider>
          <App />
        </AlertProvider>
      </DashboardThemeProvider>
    </AuthProvider>
  </ThemeProvider>
);